import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Tag as TagAnt } from 'antd'
import {
  RequestAgencyStatus,
  RequestApprovalStatus,
  RequestClosingStatus,
  RequestConferenceStatus,
  RequestUserDataStatus
} from 'src/types'

type status =
  | RequestAgencyStatus
  | RequestUserDataStatus
  | RequestApprovalStatus
  | RequestConferenceStatus
  | RequestClosingStatus

function UnifiedTag({ status }: { status: status }) {
  const color = useMemo(() => {
    switch (status) {
      case 'APPROVAL_PENDING':
      case 'APPROVED':
        return 'blue'
      case 'CONFERENCE_PENDING':
      case 'CLOSING_PENDING':
        return 'geekblue'
      case 'APPROVAL_REPROVED':
      case 'CANCELED':
      case 'CLOSING_REPROVED':
      case 'CONFERENCE_REPROVED':
      case 'EXPIRED':
      case 'REPROVED':
      case 'QUOTATION_REPROVED':
      case 'EMISSION_REPROVED':
        return 'red'
      case 'FINISHED':
        return 'purple'
      case 'PENDING':
      case 'QUOTATION_PENDING':
      case 'EMISSION_PENDING':
        return 'orange'
      case 'UNDERWAY':
        return 'green'
    }
  }, [status])

  const { t } = useTranslation()

  return (
    <TagAnt color={color}>
      {t(`common.status.unified.${status}`.toLowerCase())}
    </TagAnt>
  )
}

export default UnifiedTag
